export default {
  items: [
    {
      title: 'checklists.nav.title',
      id: 'Checklists',
      to: null,
      icon: 'icon',
      sortOrder: 10,
      expanded: true,
      children: [
        {
          title: 'checklists.nav.title',
          to: { name : 'ChecklistsIndexPage'},
          icon: 'user',
          sortOrder: 10,
        },
        {
          title: 'checklists.nav.templates',
          to: { name : 'ChecklistTemplatesIndexPage'},
          icon: 'user',
          sortOrder: 20,
        }
      ]
    }
  ]
}
